/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { behindJumpRegister } from "@/components/behindJump";
import { operationLogRegister } from "@/components/operationLog";
import components from "@/components";
import * as utils from "../utils";
import "./index.css";
import { registerResourceDataDownload } from "@/components/data-download"
import "./a.less";

type Any = {
  [key: `${string}Fns`]: { [key: string]: (...arg: any[]) => any };
  [key: `${string}Figs`]: { [key: string]: any };
};

type D = typeof utils & { [key: string]: (...arg: any[]) => any };

const toExport = {
  hbUtils: utils as unknown as D,
  registerResourceDataDownload,
  components,
  register: behindJumpRegister,
  registerLog: operationLogRegister,
};

export type LibProperties = typeof toExport & Any;
export default toExport;
